export enum DelegatedAccessStateEnum {
    Disabled = 0,
    Enabled = 1,
    Accessible = 2,
    Recoverable = 3,
}

export enum DelegatedAccessTypeEnum {
    EmergencyAccess = 1,
    SocialRecovery = 2,
}
